{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Otkaži",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Integracije",
    "DESCRIPTION": "Kontakt centar se integriše sa brojnim alatima i uslugama kako bi poboljšao efikasnost vašeg tima. Pregledajte listu ispod da biste podesili svoje omiljene aplikacije.",
    "LEARN_MORE": "Learn more about integrations",
    "LOADING": "Fetching integrations",
    "CAPTAIN": {
      "DISABLED": "Captain is not enabled on your account.",
      "CLICK_HERE_TO_CONFIGURE": "Click here to configure",
      "LOADING_CONSOLE": "Loading Captain Console...",
      "FAILED_TO_LOAD_CONSOLE": "Failed to load Captain Console. Please refresh and try again."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Pretplaćeni događaji",
      "LEARN_MORE": "Learn more about webhooks",
      "FORM": {
        "CANCEL": "Otkaži",
        "DESC": "Događaji veb zakački vam omogućavaju informacije u realnom vremenu o onome šta se događa na vašem nalogu. Molim vas unesite ispravnu adresu da bi ste podesili povratni poziv.",
        "SUBSCRIPTIONS": {
          "LABEL": "Događaji",
          "EVENTS": {
            "INBOX_CREATED": "Sanduče je napravljeno",
            "CONVERSATION_CREATED": "Razgovor je napravljen",
            "CONVERSATION_STATUS_CHANGED": "Status razgovora je promenjen",
            "CONVERSATION_UPDATED": "Razgovor je izmenjen",
            "MESSAGE_CREATED": "Poruka je napravljena",
            "MESSAGE_UPDATED": "Poruka je izmenjena",
            "WEBWIDGET_TRIGGERED": "Vidžet za ćaskanje je otvoren od strane korisnika",
            "CONTACT_CREATED": "Contact created",
            "CONTACT_UPDATED": "Contact updated",
            "JARABOT_EVENT": "Internal events"
          }
        },
        "END_POINT": {
          "LABEL": "Adresa veb zakačke",
          "PLACEHOLDER": "Example: {webhookExampleURL}",
          "ERROR": "Molim vas unesite ispravnu adresu"
        },
        "EDIT_SUBMIT": "Izmeni veb zakačku",
        "ADD_SUBMIT": "Napravi veb zakačku"
      },
      "TITLE": "Veb zakačka",
      "CONFIGURE": "Podesi",
      "HEADER": "Podešavanja veb zakačke",
      "HEADER_BTN_TXT": "Dodaj novu veb zakačku",
      "LOADING": "Prikupljanje dodatih veb zakački",
      "SEARCH_404": "Nema razultata",
      "SIDEBAR_TXT": "<p><b>Veb zakačke</b> </p> <p>Veb zakačke su HTTP povratni pozivi koji mogu biti definisani za svaki nalog. Pozivaju ih događaji kao što je pravljenje poruke. Možete kreirati više od jedne veb zakačke za ovaj nalog. <br /><br /> Za kreiranje <b>veb zakačke</b>, kliknite na dugem <b>Dodaj novu veb zakačku</b>. Takođe možete ukloniti postojeće veb zakačke klikom na dugme Obriši.</p>",
      "LIST": {
        "404": "Nema veb zakački podešenih za ovaj nalog.",
        "TITLE": "Upravljanje veb zakačkama",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Krajnje tačke veb zakački",
          "ACTIONS": "Akcije"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Uredi",
        "TITLE": "Uredi veb zakačku",
        "API": {
          "SUCCESS_MESSAGE": "Veb zakačka je uspešno izmenjena",
          "ERROR_MESSAGE": "Nije moguće se povezati sa Woot serverom, pokušajte ponovo kasnije"
        }
      },
      "ADD": {
        "CANCEL": "Otkaži",
        "TITLE": "Dodaj novu veb zakačku",
        "API": {
          "SUCCESS_MESSAGE": "Podešavanje veb zakačke je uspešno dodato",
          "ERROR_MESSAGE": "Nije moguće se povezati sa Woot serverom, pokušajte ponovo kasnije"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Izbriši",
        "API": {
          "SUCCESS_MESSAGE": "Veb zakačka je uspešno obrisana",
          "ERROR_MESSAGE": "Nije moguće se povezati sa Woot serverom, pokušajte ponovo kasnije"
        },
        "CONFIRM": {
          "TITLE": "Potvrdite brisanje",
          "MESSAGE": "Da li zaista želite da obrišete veb zakačku? ({webhookURL})",
          "YES": "Da, izbriši ",
          "NO": "Ne, zadrži je"
        }
      },
      "DISABLED_BADGE": "Onemogućeno",
      "DISABLED_REASON": "Automatski onemogućeno nakon {count} uzastopnih neuspeha. Poslednja greška: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Omogući",
        "API": {
          "SUCCESS_MESSAGE": "Veb zakačka je uspešno omogućena",
          "ERROR_MESSAGE": "Nije moguće omogućiti veb zakačku, pokušajte ponovo kasnije"
        }
      }
    },
    "SLACK": {
      "DELETE": "Izbriši",
      "DELETE_CONFIRMATION": {
        "TITLE": "Delete the integration",
        "MESSAGE": "Are you sure you want to delete the integration? Doing so will result in the loss of access to conversations on your Slack workspace."
      },
      "HELP_TEXT": {
        "TITLE": "Koristi Slack integraciju",
        "BODY": "Uz ovu integraciju, svi vaši dolazni razgovori biće sinhronizovani sa kanalom ***{selectedChannelName}*** u vašem Slack radnom prostoru. Sve razgovore sa klijentima možete voditi direktno u kanalu i nikada nećete propustiti poruku.\n\nOvo su glavne funkcije integracije:\n\n**Odgovarajte na razgovore iz Slack-a:** Da biste odgovorili na razgovor u Slack kanalu ***{selectedChannelName}***, napišite poruku i pošaljite je kao nit. Tako se klijentu šalje odgovor preko kontakt centra. Tako je jednostavno!\n\n **Pravite privatne beleške:** Ako umesto odgovora želite da napravite privatne beleške, počnite poruku sa ***`note:`***. Tako poruka ostaje privatna i klijent je neće videti.\n\n**Povežite profil agenta:** Ako osoba koja je odgovorila u Slack-u ima profil agenta u kontakt centru sa istom e-poštom, odgovori će se automatski povezati sa tim profilom agenta. Tako lako pratite ko je šta i kada rekao. S druge strane, ako osoba koja odgovara nema povezan profil agenta, klijent će videti odgovore od profila bota.",
        "SELECTED": "selected"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Select a channel",
        "UPDATE": "Primeni",
        "BUTTON_TEXT": "Connect channel",
        "DESCRIPTION": "Vaš Slack radni prostor je sada povezan sa kontakt centrom. Međutim, integracija trenutno nije aktivna. Da biste aktivirali integraciju i povezali kanal, kliknite na dugme ispod.\n\n**Napomena:** Ako pokušavate da povežete privatni kanal, pre ovog koraka dodajte našu aplikaciju u Slack kanal.",
        "ATTENTION_REQUIRED": "Attention required",
        "EXPIRED": "Your Slack integration has expired. To continue receiving messages on Slack, please delete the integration and connect your workspace again."
      },
      "UPDATE_ERROR": "There was an error updating the integration, please try again",
      "UPDATE_SUCCESS": "The channel is connected successfully",
      "FAILED_TO_FETCH_CHANNELS": "There was an error fetching the channels from Slack, please try again"
    },
    "OPEN_AI": {
      "AI_ASSIST": "AI pomoć",
      "WITH_AI": " {option} sa AI ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Predlog odgovora",
        "SUMMARIZE": "Sažmi",
        "REPHRASE": "Poboljšaj pisanje",
        "FIX_SPELLING_GRAMMAR": "Ispravi pravopis i gramatiku",
        "SHORTEN": "Skrati",
        "EXPAND": "Proširi",
        "MAKE_FRIENDLY": "Promeni ton poruke u prijateljski",
        "MAKE_FORMAL": "Koristi formalni ton",
        "SIMPLIFY": "Pojednostavi",
        "TRANSLATE": "Преведи",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Prevedi na većinski jezik"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Sadržaj nacrta",
        "GENERATED_TITLE": "Generisani sadržaj",
        "AI_WRITING": "AI piše",
        "BUTTONS": {
          "APPLY": "Koristi ovaj predlog",
          "CANCEL": "Otkaži"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integriši se sa OpenAI",
        "DESC": "Donesite napredne AI funkcije na vašu radnu tablu uz GPT modele kompanije OpenAI. Za početak, unesite API ključ sa svog OpenAI naloga.",
        "KEY_PLACEHOLDER": "Unesite svoj OpenAI API ključ",
        "BUTTONS": {
          "NEED_HELP": "Treba vam pomoć?",
          "DISMISS": "Odbaci",
          "FINISH": "Završi podešavanje"
        },
        "DISMISS_MESSAGE": "Možete podesiti OpenAI integraciju kasnije, kad god želite.",
        "SUCCESS_MESSAGE": "OpenAI integracija je uspešno podešena"
      },
      "TITLE": "Poboljšaj uz AI",
      "SUMMARY_TITLE": "Sažetak uz AI",
      "REPLY_TITLE": "Predlog odgovora uz AI",
      "SUBTITLE": "Poboljšani odgovor će biti generisan pomoću AI, na osnovu vašeg trenutnog nacrta.",
      "TONE": {
        "TITLE": "Ton",
        "OPTIONS": {
          "PROFESSIONAL": "Profesionalan",
          "FRIENDLY": "Prijateljski"
        }
      },
      "BUTTONS": {
        "GENERATE": "Generiši",
        "GENERATING": "Generisanje...",
        "CANCEL": "Otkaži"
      },
      "GENERATE_ERROR": "There was an error processing the content, please try again"
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "API": {
        "SUCCESS_MESSAGE": "Integracija je uspešno obrisana"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Poveži se"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Aplikacije radne table",
      "HEADER_BTN_TXT": "Dodaj novu aplikaciju radne table",
      "SIDEBAR_TXT": "<p><b>Aplikacije radne table</b></p><p>Aplikacije radne table omogućavaju organizacijama da integrišu aplikaciju unutar radne table da dostave kontekst agentima podrške. Ova mogućnosti vam omogućava da napravite aplikaciju nezavisno i integrišete je unutar radne table da bi ste dostavili informacije o korisniku, njihovim narudžbama ili istoriji prethodnih plaćanja.</p><p>Kada integrišete vašu aplikaciju u radnu tablu, vaša aplikacija će dobiti kontakst razgovora i kontakta kao window događaj. Implementirajte osluškivač događaj poruke na vašoj stranici da bi ste primili kontakst.</p><p>Da bi ste dodali novu aplikaciju radne table, kliknite na dugme 'Dodaj novu aplikaciju radne table'.</p>",
      "DESCRIPTION": "Aplikacije radne table omogućavaju organizacijama da integrišu aplikaciju unutar radne table da bi omogućili kontekst agentima podrške. Ova mogućnost omogućava da nezavisno napravite aplikaciju i integrišete je da bi ste dostavili informacije o korisniku, njihovim narudžbama ili njihovoj istoriji plaćanja.",
      "LEARN_MORE": "Learn more about Dashboard Apps",
      "LIST": {
        "404": "Još uvek nema aplikacija radne table podešenih za ovaj nalog",
        "LOADING": "Prikupljanje aplikacija radne table...",
        "TABLE_HEADER": {
          "NAME": "Ime",
          "ENDPOINT": "Krajnja tačka"
        },
        "EDIT_TOOLTIP": "Uredi aplikaciju",
        "DELETE_TOOLTIP": "Obriši aplikaciju"
      },
      "FORM": {
        "TITLE_LABEL": "Ime",
        "TITLE_PLACEHOLDER": "Unesite naziv vaše aplikacije radne table",
        "TITLE_ERROR": "Naziv aplikacije radne table je obavezno",
        "URL_LABEL": "Krajnja tačka",
        "URL_PLACEHOLDER": "Unesite adresu krajnje tačke gde je hostovana vaša aplikacija",
        "URL_ERROR": "Ispravna adresa je obavezna"
      },
      "CREATE": {
        "HEADER": "Dodaj novu aplikaciju radne table",
        "FORM_SUBMIT": "Pošalji",
        "FORM_CANCEL": "Otkaži",
        "API_SUCCESS": "Aplikacija radne table je uspešno podešena",
        "API_ERROR": "Nismo mogli da napravimo aplikaciju. Molim vas pokušajte ponovo"
      },
      "UPDATE": {
        "HEADER": "Uredi aplikaciju radne table",
        "FORM_SUBMIT": "Primeni",
        "FORM_CANCEL": "Otkaži",
        "API_SUCCESS": "Aplikacija radne table je uspešno izmenjena",
        "API_ERROR": "Nismo mogli da izmenimo aplikaciju. Molim vas pokušajte ponovo"
      },
      "DELETE": {
        "CONFIRM_YES": "Da, obriši je",
        "CONFIRM_NO": "Ne, zadrži je",
        "TITLE": "Potvrdi brisanje",
        "MESSAGE": "Da li zaista želite da obrišete aplikaciju - {appName}?",
        "API_SUCCESS": "Aplikacija radne table je uspešno obrisana",
        "API_ERROR": "Nismo mogli da obrišemo aplikaciju. Molim vas pokušajte ponovo"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Create/Link Linear Issue",
      "LOADING": "Fetching linear issues...",
      "LOADING_ERROR": "There was an error fetching the linear issues, please try again",
      "CREATE": "Napravi",
      "LINK": {
        "SEARCH": "Search issues",
        "SELECT": "Select issue",
        "TITLE": "Veza",
        "EMPTY_LIST": "No linear issues found",
        "LOADING": "Loading",
        "ERROR": "There was an error fetching the linear issues, please try again",
        "LINK_SUCCESS": "Issue linked successfully",
        "LINK_ERROR": "There was an error linking the issue, please try again",
        "LINK_TITLE": "Conversation (#{conversationId}) with {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Create/link linear issue",
        "DESCRIPTION": "Create Linear issues from conversations, or link existing ones for seamless tracking.",
        "FORM": {
          "TITLE": {
            "LABEL": "Naslov",
            "PLACEHOLDER": "Enter title",
            "REQUIRED_ERROR": "Naslov je obavezan"
          },
          "DESCRIPTION": {
            "LABEL": "Opis",
            "PLACEHOLDER": "Enter description"
          },
          "TEAM": {
            "LABEL": "Tim",
            "PLACEHOLDER": "Izaberite tim",
            "SEARCH": "Search team",
            "REQUIRED_ERROR": "Team is required"
          },
          "ASSIGNEE": {
            "LABEL": "Assignee",
            "PLACEHOLDER": "Select assignee",
            "SEARCH": "Search assignee"
          },
          "PRIORITY": {
            "LABEL": "Prioritet",
            "PLACEHOLDER": "Select priority",
            "SEARCH": "Search priority"
          },
          "LABEL": {
            "LABEL": "Oznaka",
            "PLACEHOLDER": "Select label",
            "SEARCH": "Search label"
          },
          "STATUS": {
            "LABEL": "Status",
            "PLACEHOLDER": "Select status",
            "SEARCH": "Search status"
          },
          "PROJECT": {
            "LABEL": "Project",
            "PLACEHOLDER": "Select project",
            "SEARCH": "Search project"
          }
        },
        "CREATE": "Napravi",
        "CANCEL": "Otkaži",
        "CREATE_SUCCESS": "Issue created successfully",
        "CREATE_ERROR": "There was an error creating the issue, please try again",
        "LOADING_TEAM_ERROR": "There was an error fetching the teams, please try again",
        "LOADING_TEAM_ENTITIES_ERROR": "There was an error fetching the team entities, please try again"
      },
      "ISSUE": {
        "STATUS": "Status",
        "PRIORITY": "Prioritet",
        "ASSIGNEE": "Assignee",
        "LABELS": "Oznake",
        "CREATED_AT": "Created at {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Unlink",
        "SUCCESS": "Issue unlinked successfully",
        "ERROR": "There was an error unlinking the issue, please try again"
      },
      "DELETE": {
        "TITLE": "Are you sure you want to delete the integration?",
        "MESSAGE": "Are you sure you want to delete the integration?",
        "CONFIRM": "Yes, delete",
        "CANCEL": "Otkaži"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "Know more",
    "COPILOT": {
      "SEND_MESSAGE": "Pošalji poruku...",
      "EMPTY_MESSAGE": "Došlo je do greške prilikom generisanja odgovora. Pokušajte ponovo.",
      "LOADER": "Captain is thinking",
      "YOU": "You",
      "USE": "Use this",
      "RESET": "Reset",
      "SELECT_ASSISTANT": "Select Assistant"
    },
    "PAYWALL": {
      "TITLE": "Upgrade to use Captain AI",
      "AVAILABLE_ON": "Captain is not available on the free plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "UPGRADE_NOW": "Upgrade now",
      "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI feature is only available in a paid plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
    },
    "BANNER": {
      "RESPONSES": "You've used over 80% of your response limit. To continue using Captain AI, please upgrade.",
      "DOCUMENTS": "Document limit reached. Upgrade to continue using Captain AI."
    },
    "FORM": {
      "CANCEL": "Otkaži",
      "CREATE": "Napravi",
      "EDIT": "Primeni"
    },
    "ASSISTANTS": {
      "HEADER": "Assistants",
      "ADD_NEW": "Create a new assistant",
      "DELETE": {
        "TITLE": "Are you sure to delete the assistant?",
        "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "The assistant has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the assistant, please try again."
      },
      "FORM_DESCRIPTION": "Fill out the details below to name your assistant, describe its purpose, and specify the product it will support.",
      "CREATE": {
        "TITLE": "Create an assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the assistant, please try again."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Assistant Name",
          "PLACEHOLDER": "Enter a name for the assistant",
          "ERROR": "Please provide a name for the assistant"
        },
        "DESCRIPTION": {
          "LABEL": "Assistant Description",
          "PLACEHOLDER": "Describe how and where this assistant will be used",
          "ERROR": "A description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Product Name",
          "PLACEHOLDER": "Enter the name of the product this assistant is designed for",
          "ERROR": "The product name is required"
        },
        "FEATURES": {
          "TITLE": "Mogućnosti",
          "ALLOW_CONVERSATION_FAQS": "Generate FAQs from resolved conversations",
          "ALLOW_MEMORIES": "Capture key details as memories from customer interactions."
        }
      },
      "EDIT": {
        "TITLE": "Update the assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the assistant, please try again."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Edit Assistant",
        "DELETE_ASSISTANT": "Delete Assistant",
        "VIEW_CONNECTED_INBOXES": "View connected inboxes"
      },
      "EMPTY_STATE": {
        "TITLE": "No assistants available",
        "SUBTITLE": "Create an assistant to provide quick and accurate responses to your users. It can learn from your help articles and past conversations.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Documents",
      "ADD_NEW": "Create a new document",
      "RELATED_RESPONSES": {
        "TITLE": "Related FAQs",
        "DESCRIPTION": "These FAQs are generated directly from the document."
      },
      "FORM_DESCRIPTION": "Enter the URL of the document to add it as a knowledge source and choose the assistant to associate it with.",
      "CREATE": {
        "TITLE": "Add a document",
        "SUCCESS_MESSAGE": "The document has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the document, please try again."
      },
      "FORM": {
        "URL": {
          "LABEL": "Adresa",
          "PLACEHOLDER": "Enter the URL of the document",
          "ERROR": "Please provide a valid URL for the document"
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select the assistant",
          "ERROR": "The assistant field is required"
        }
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the document?",
        "DESCRIPTION": "This action is permanent. Deleting this document will permanently erase all generated knowledge.",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "The document has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the document, please try again."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "View Related Responses",
        "DELETE_DOCUMENT": "Delete Document"
      },
      "EMPTY_STATE": {
        "TITLE": "No documents available",
        "SUBTITLE": "Documents are used by your assistant to generate FAQs. You can import documents to provide context for your assistant.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQs",
      "ADD_NEW": "Create new FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Conversation #{id}"
      },
      "SELECTED": "{count} selected",
      "BULK_APPROVE_BUTTON": "Approve",
      "BULK_DELETE_BUTTON": "Izbriši",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQs approved successfully",
        "ERROR_MESSAGE": "There was an error approving the FAQs, please try again."
      },
      "BULK_DELETE": {
        "TITLE": "Delete FAQs?",
        "DESCRIPTION": "Are you sure you want to delete the selected FAQs? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "FAQs deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQs, please try again."
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "FAQ deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQ, please try again."
      },
      "FILTER": {
        "ASSISTANT": "Assistant: {selected}",
        "STATUS": "Status: {selected}",
        "ALL_ASSISTANTS": "Sve"
      },
      "STATUS": {
        "TITLE": "Status",
        "PENDING": "Nerešen",
        "APPROVED": "Approved",
        "ALL": "Sve"
      },
      "FORM_DESCRIPTION": "Add a question and its corresponding answer to the knowledge base and select the assistant it should be associated with.",
      "CREATE": {
        "TITLE": "Add an FAQ",
        "SUCCESS_MESSAGE": "The response has been added successfully.",
        "ERROR_MESSAGE": "An error occurred while adding the response. Please try again."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Question",
          "PLACEHOLDER": "Enter the question here",
          "ERROR": "Please provide a valid question."
        },
        "ANSWER": {
          "LABEL": "Answer",
          "PLACEHOLDER": "Enter the answer here",
          "ERROR": "Please provide a valid answer."
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select an assistant",
          "ERROR": "Please select an assistant."
        }
      },
      "EDIT": {
        "TITLE": "Update the FAQ",
        "SUCCESS_MESSAGE": "The FAQ has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the FAQ, please try again",
        "APPROVE_SUCCESS_MESSAGE": "The FAQ was marked as approved"
      },
      "OPTIONS": {
        "APPROVE": "Mark as approved",
        "EDIT_RESPONSE": "Edit FAQ",
        "DELETE_RESPONSE": "Delete FAQ"
      },
      "EMPTY_STATE": {
        "TITLE": "No FAQs Found",
        "SUBTITLE": "FAQs help your assistant provide quick and accurate answers to questions from your customers. They can be generated automatically from your content or can be added manually.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Connected Inboxes",
      "ADD_NEW": "Connect a new inbox",
      "OPTIONS": {
        "DISCONNECT": "Prekini vezu"
      },
      "DELETE": {
        "TITLE": "Are you sure to disconnect the inbox?",
        "DESCRIPTION": "",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "The inbox was successfully disconnected.",
        "ERROR_MESSAGE": "There was an error disconnecting the inbox, please try again."
      },
      "FORM_DESCRIPTION": "Choose an inbox to connect with the assistant.",
      "CREATE": {
        "TITLE": "Connect an Inbox",
        "SUCCESS_MESSAGE": "The inbox was successfully connected.",
        "ERROR_MESSAGE": "An error occurred while connecting the inbox. Please try again."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Prijemno sanduče",
          "PLACEHOLDER": "Choose the inbox to deploy the assistant.",
          "ERROR": "An inbox selection is required."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No Connected Inboxes",
        "SUBTITLE": "Connecting an inbox allows the assistant to handle initial questions from your customers before transferring them to you."
      }
    }
  }
}
